'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getClosestPointTo = exports.isOverlappingHorizontally = exports.getYOverlapFraction = exports.getXOverlapFraction = exports.get1DOverlapFraction = exports.getYOverlap = exports.getXOverlap = exports.getOverlap = exports.getLength = exports.getDy = exports.getDx = exports.get1DDelta = exports.getCenter = exports.getPointAlong = exports.getNewLine = exports.combineLines = exports.isAligned = exports.isVerticallyAligned = exports.isHorizontallyAligned = exports.isAlignedAlongDimension = exports.isVertical = exports.isHorizontal = exports.isFlatAlongDimension = exports.lineComparison = exports.chooseLine = exports.getLine = undefined;

var _point = require('./point');

var pointLib = _interopRequireWildcard(_point);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// √
var getLine = exports.getLine = function getLine(point1, point2) {
    return {
        start: point1,
        end: point2
    };
};

// √
// Points
var chooseLine = exports.chooseLine = function chooseLine(line1, line2, compFn) {
    return compFn(line1, line2) ? line1 : line2;
};
// Assumes horizontal or vertical lines
var lineComparison = exports.lineComparison = {
    // Horizontal
    leftmost: function leftmost(line1, line2) {
        return line1.start.x < line2.start.x;
    },
    rightmost: function rightmost(line1, line2) {
        return line1.start.x > line2.start.x;
    },
    // Vertical
    upper: function upper(line1, line2) {
        return line1.start.y < line2.start.y;
    },
    lower: function lower(line1, line2) {
        return line1.start.y > line2.start.y;
    }
};

// √
var isFlatAlongDimension = exports.isFlatAlongDimension = function isFlatAlongDimension(line, dimension) {
    return line.start[dimension] === line.end[dimension];
};
var isHorizontal = exports.isHorizontal = function isHorizontal(line) {
    return isFlatAlongDimension(line, 'y');
};
var isVertical = exports.isVertical = function isVertical(line) {
    return isFlatAlongDimension(line, 'x');
};

// √
var isAlignedAlongDimension = exports.isAlignedAlongDimension = function isAlignedAlongDimension(line1, line2, dimension) {
    return (
        // Start inline
        line1.start[dimension] === line2.start[dimension] &&
        // Remain inline
        isFlatAlongDimension(line1, dimension) && isFlatAlongDimension(line2, dimension)
    );
};
var isHorizontallyAligned = exports.isHorizontallyAligned = function isHorizontallyAligned(line1, line2) {
    return isAlignedAlongDimension(line1, line2, 'y');
};
var isVerticallyAligned = exports.isVerticallyAligned = function isVerticallyAligned(line1, line2) {
    return isAlignedAlongDimension(line1, line2, 'x');
};
var isAligned = exports.isAligned = function isAligned(line1, line2) {
    return isHorizontal(line1) ? isHorizontallyAligned(line1, line2) : isVerticallyAligned(line1, line2);
};

/**
 * Simply combines two lines by taking the min start and max end values.
 * Currently this assumes that all lines are moving in positive directions (i.e. end is not < start).
 */
// √
var combineLines = exports.combineLines = function combineLines(line1, line2) {
    return getLine(pointLib.getPoint(Math.min(line1.start.x, line2.start.x), Math.min(line1.start.y, line2.start.y)), pointLib.getPoint(Math.max(line1.end.x, line2.end.x), Math.max(line1.end.y, line2.end.y)));
};

// √
var getNewLine = exports.getNewLine = function getNewLine(line1, line2, selectionStrategy) {
    return isAligned(line1, line2) ? combineLines(line1, line2) : chooseLine(line1, line2, selectionStrategy);
};

// √
var getPointAlong = exports.getPointAlong = function getPointAlong(line, fraction) {
    return pointLib.getPointBetween(line.start, line.end, fraction);
};
var getCenter = exports.getCenter = function getCenter(line) {
    return getPointAlong(line);
};

// √
var get1DDelta = exports.get1DDelta = function get1DDelta(line, dimension) {
    return pointLib.get1DDelta(line.start, line.end, dimension);
};
var getDx = exports.getDx = function getDx(line) {
    return pointLib.getXDelta(line.start, line.end);
};
var getDy = exports.getDy = function getDy(line) {
    return pointLib.getYDelta(line.start, line.end);
};
var getLength = exports.getLength = function getLength(line) {
    return pointLib.getDistance(line.start, line.end);
};

// √
var getOverlap = exports.getOverlap = function getOverlap(line1, line2, dimension) {
    return Math.max(0, Math.min(line1.end[dimension], line2.end[dimension]) - Math.max(line1.start[dimension], line2.start[dimension]));
};
var getXOverlap = exports.getXOverlap = function getXOverlap(line1, line2) {
    return getOverlap(line1, line2, 'x');
};
var getYOverlap = exports.getYOverlap = function getYOverlap(line1, line2) {
    return getOverlap(line1, line2, 'y');
};
var get1DOverlapFraction = exports.get1DOverlapFraction = function get1DOverlapFraction(line1, line2, dimension) {
    return getOverlap(line1, line2, dimension) / Math.min(get1DDelta(line1, dimension), get1DDelta(line2, dimension));
};
var getXOverlapFraction = exports.getXOverlapFraction = function getXOverlapFraction(line1, line2) {
    return get1DOverlapFraction(line1, line2, 'x');
};
var getYOverlapFraction = exports.getYOverlapFraction = function getYOverlapFraction(line1, line2) {
    return get1DOverlapFraction(line1, line2, 'y');
};
// TODO Prefer - "isInlineHorizontally"
var isOverlappingHorizontally = exports.isOverlappingHorizontally = function isOverlappingHorizontally(line1, line2) {
    var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return getXOverlapFraction(line1, line2) > threshold;
};

// √
var getClosestPointTo = exports.getClosestPointTo = function getClosestPointTo(line, point) {
    var A = pointLib.getXDelta(point, line.start);
    var B = pointLib.getYDelta(point, line.start);
    // TODO Not sure why -1
    var C = -1 * getDx(line);
    var D = -1 * getDy(line);

    var dot = A * C + B * D;
    var lengthSq = C * C + D * D;

    // The ratio along the line that the closest point is
    var ratio = lengthSq === 0 ? -1 : dot / lengthSq;

    // Start of the line
    if (ratio < 0) {
        return line.start;
        // End of the line
    } else if (ratio > 1) {
        return line.end;
    }

    // Otherwise it's some point along the line
    return getPointAlong(line, ratio);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/geometry/line.js
// module id = 480
// module chunks = 0